<!--
 * @Description: 子客户代码
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-02-23 11:36:23
 * @LastEditors: cxh
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="searchFrom"
        @fetch="fetch"
        @mask="showMask"
        ref="tableRef"
        tableId="fbuAccountCode"
      >
        <template #search>
          <a-form :model="searchFrom">
            <dc-form-item label="主客户代码">
              <a-input v-model:value="searchFrom.customerNumber" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="客户名称">
              <a-input v-model:value="searchFrom.customerName" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="手机号">
              <a-input v-model:value="searchFrom.arkContactMobile" placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="stage" label="客户阶段">
              <a-select
                v-model:value="searchFrom.stage"
                placeholder="请选择"
                mode="multiple"
                allowClear
                :options="dataConfig.customerPhaseEnum"
              />
            </dc-form-item>
            <dc-form-item label="子客户代码">
              <a-input v-model:value="searchFrom.arkCode" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item label="子客户代码名称">
              <a-input v-model:value="searchFrom.arkAccount" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="level" label="档次">
              <a-select
                v-model:value="searchFrom.level"
                :fieldNames="{ label: 'configName', value: 'id' }"
                mode="multiple"
                allowClear
                placeholder="请选择"
                :options="level"
              />
            </dc-form-item>
            <dc-form-item name="seller" label="客户负责人">
              <user-select v-model:value="searchFrom.seller" />
            </dc-form-item>
            <dc-form-item name="createTime" label="创建时间">
              <cos-range-picker
                v-model:startTime="searchFrom.createTimeStart"
                v-model:endTime="searchFrom.createTimeEnd"
              />
            </dc-form-item>
          </a-form>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit" v-permission="'fbu_arkcode_add_btn'"> 新增 </a-button>
          <ExportButton appId="cos_fbu" taskType="206" :search="searchFrom" v-permission="'fbu_arkcode_export_btn'"
            >导出</ExportButton
          >
        </template>
        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'action'">
            <MoreButton>
              <a-button type="link" @click="addEdit(record)" v-permission="'fbu_arkcode_edit_btn'"> 编辑 </a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="'fbu_arkcode_del_btn'"> 删除 </a-button>
            </MoreButton>
          </template>
          <template v-if="column.dataIndex === 'subjectCount'">
            <a-button type="link" @click="linkToMainBody(record)"> {{ text || 0 }} </a-button>
          </template>
        </template>
      </cos-table>
      <editModal ref="editModalRef" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import { onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import dataConfig from '@/views/gucangSales/commonEnum/dataConfig'
import CosRangePicker from '@/components/CosRangePicker/index'
import { CustomerCodeParams, CustomerCode } from '@/typings/api/customerCenter'
import { customerCodeGet, customerCodeDelete, customerCodeDetail } from '@/api/gucangSales/customerCenter'
import { getLevelOrGrade } from '@/api/common'
import editModal from './editModal.vue'
import { useRouter } from 'vue-router'
export default { name: 'DcCosFbuAccountCode' }
</script>
<script setup lang="ts">
const router = useRouter()
const editModalRef = ref()
const tableRef = ref()
const level = ref<
  {
    id: number
    max: number
    min: number
    configName: string
  }[]
>([])
const searchFrom = ref<CustomerCodeParams>({
  stage: [],
  contact: {
    type: 1
  },
  content: ''
})
const columns = ref([
  {
    title: '子客户代码名称',
    dataIndex: 'arkAccount',
    cosType: 'link',
    path: '/fbu/accountCode/view',
    query: ['id', 'arkCode', 'cosId'],
    fixed: 'left',
    width: 150
  },
  {
    title: '子客户代码',
    dataIndex: 'arkCode'
  },
  {
    title: '主客户代码',
    dataIndex: 'customerNumber'
  },
  {
    title: '客户名称',
    dataIndex: 'customerName'
  },
  {
    title: '客户ID',
    dataIndex: 'cosId',
    width: 120
  },
  {
    title: '联系人姓名',
    dataIndex: 'arkContactName',
    cosType: 'mask',
    width: 120,
    headerQuestion: '取值来源：ark账号审核-联系人姓名'
  },
  {
    title: '手机号',
    dataIndex: 'arkContactMobile',
    cosType: 'mask',
    headerQuestion: '取值来源：ark账号审核-手机号'
  },
  {
    title: '客户负责人',
    dataIndex: 'sellerName',
    headerQuestion: '取值来源：ark账号审核-销售代表',
    width: 120
  },
  {
    title: '客户阶段',
    dataIndex: 'stage',
    dicData: dataConfig.customerPhaseEnum
  },
  {
    title: '档次',
    dataIndex: 'level'
  },
  {
    title: '成交金额（万）',
    dataIndex: 'amount',
    width: 120
  },
  {
    title: 'ark账号状态',
    dataIndex: 'status',
    dicData: [
      { value: 0, label: '待审核' },
      { value: 1, label: '审核不通过' },
      { value: 2, label: '审核通过' },
      { value: 3, label: '已停用' },
      { value: 4, label: '冻结' },
      { value: 5, label: '限制' }
    ]
  },
  {
    title: '主体数量',
    dataIndex: 'subjectCount'
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 190
  },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right',
    width: 120
  }
])
const fetch = (params: CustomerCodeParams, callBack: (res: any) => void) => {
  // 重组档次搜索
  const levelList: { min: number; max: number }[] = []
  if (searchFrom.value.level && searchFrom.value.level.length) {
    searchFrom.value.level.forEach((item) => {
      const obj = level.value.find((v: any) => item === v.id)
      if (obj) {
        levelList.push({
          min: obj.min,
          max: obj.max
        })
      }
    })
  }
  searchFrom.value.levelList = levelList
  customerCodeGet({
    ...params,
    levelList
  }).then((res) => {
    callBack(res)
  })
}
const showMask = (record: CustomerCode, callBack: (res: any) => void) => {
  if (record.id) {
    customerCodeDetail(record.id).then((res) => {
      callBack(res.data)
    })
  }
}
onMounted(() => {
  fetchLevel()
})
const fetchLevel = () => {
  getLevelOrGrade({
    configType: 1,
    appId: 'cos_fbu'
  }).then((res) => {
    level.value = res.data
  })
}
const addEdit = (row: CustomerCode) => {
  editModalRef.value?.toggle(row)
}
const deleteRow = (row: CustomerCode) => {
  Modal.delete({
    name: row.arkCode,
    onOk() {
      customerCodeDelete({ idList: [row.id] }).then(() => {
        message.success('删除成功')
        tableRef.value.delFetch()
      })
    }
  })
}
const success = (type = 'edit') => {
  if (type === 'add') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// 跳转到签约主体列表
const linkToMainBody = (row: CustomerCode) => {
  if (!row.subjectCount) {
    return
  }
  router.push({
    path: '/fbu/mainBody',
    query: {
      customerCode: row.arkCode
    }
  })
}
</script>
